export const DATE_ONLY_FORMAT = 'yyyy-MM-dd';
export const DATE_AND_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const DATE_TIME_AND_TIMEZONE_FORMAT = 'yyyy-MM-dd HH:mm zzz';
export const DATE_TIME_API_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_TIME_AND_TIMEZONE_API_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
